import React, { FormEventHandler, MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";
import { useScrollLock } from "../common/useScrollLock";
import { modalClasses, textClasses, buttonClasses } from "../common/tailwindClassnames";

type GundiV1ModalProps = {
    helpCenterUrl: string,
    onToggleModal: MouseEventHandler,
}

const GundiV1Modal = ({
    helpCenterUrl,
    onToggleModal,
}: GundiV1ModalProps) => {
    const { t } = useTranslation();

    useScrollLock(true);

    return (
        <div className="fixed inset-0 z-50">
            <div className="fixed inset-0 bg-dark-gray opacity-80 transition-colors duration-300"
                onClick={onToggleModal}></div>
            <div className="fixed inset-0 flex items-center justify-center p-4 overflow-y-auto">
                <div className="z-20 flex flex-col bg-very-light-gray w-full sm:w-4/5 md:w-2/3 lg:w-1/2 xl:w-1/3 
                                my-4 overflow-y-auto shadow rounded-lg transition-colors duration-300">
                    <div className="flex flex-row-reverse sticky top-0 bg-very-light-gray z-10 transition-colors duration-300">
                        <button
                            type="button"
                            onClick={onToggleModal}
                            className="text-medium-gray bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center transition-colors duration-300"
                            data-modal-hide="authentication-modal"
                        >
                            <svg aria-hidden="true" className="w-7 h-7 text-off-black transition-colors duration-300" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                            <span className="sr-only">{t("Close Modal")}</span>
                        </button>
                    </div>
                    <div className="px-4 sm:px-6 pb-6 h-full">
                        <h2 className="text-lg sm:text-xl md:text-2xl mb-2 sm:mb-[8px] text-off-black transition-colors duration-300">{t("Assistance needed for this Connection")}</h2>
                        <p className="text-secondary-gray text-sm sm:text-md mb-4 sm:mb-[32px] transition-colors duration-300">{t("Integrations with this technology are supported but cannot be configured directly in this portal. For assistance, please visit the Help Center for guidance or contact Support.")}</p>
                        <div className="flex flex-col sm:flex-row gap-2 sm:gap-0 mb-2">
                            <button onClick={() => window.open(helpCenterUrl, "_blank")} className="mr-0 sm:mr-3 bg-dark-green hover:bg-status-green text-light-green font-bold px-4 py-2 rounded-sm transition-colors duration-300">{t("Help Center")}</button>
                            <button onClick={() => window.open("https://support.earthranger.com/en_US/gundi-getting-help/gundi-contact-us", "_blank")} className="bg-light-green text-dark-green font-bold px-4 py-2 rounded-sm hover:bg-light-green-hover transition-colors duration-300">{t("Contact Support")}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GundiV1Modal;